var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientPerMonthIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FE045FC3-84C9-4A81-8B5B-F3AED74E2595") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Accounts-Health-System-Info-Copy-14",
    transform: "translate(-511.000000, -518.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(511.000000, 518.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C5.24036024,0 3,2.24057596 3,5 C3,7.75963976 5.24057596,10 8,10 C10.7596398,10 13,7.75942404 13,5 C13,2.24036024 10.759424,0 8,0 Z M8,1.41562854 C9.97810495,1.41562854 11.5843715,3.02189505 11.5843715,5 C11.5843715,6.97810495 9.97810495,8.58437146 8,8.58437146 C6.02189505,8.58437146 4.41562854,6.97810495 4.41562854,5 C4.41562854,3.02189505 6.02189505,1.41562854 8,1.41562854 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.3073114 C0,19.6897336 0.325882731,20 0.727395014,20 L15.2727331,20 C15.6742454,20 16,19.6897336 16,19.3073114 L16,16.6177798 C16,14.5970292 15.1573678,12.6593484 13.6571755,11.2314335 C12.1569832,9.80256877 10.1225752,9 8.00194802,9 L7.99805198,9 C5.87731398,9 3.84290603,9.80256877 2.34282453,11.2314335 C0.842632214,12.6592956 0,14.5969764 0,16.6177798 L0,19.3073114 L0,19.3073114 Z M1.45466192,18.6146229 L1.45466192,16.6177798 C1.45466192,14.9646159 2.14402783,13.3796917 3.37065697,12.2103278 C4.59833891,11.0420195 6.26221477,10.3854299 7.99812468,10.3854299 L8.00202072,10.3854299 C9.73770899,10.3854299 11.4017511,11.0420195 12.6294884,12.2103278 C13.8561176,13.3796389 14.5454835,14.9644048 14.5454835,16.6177798 L14.5454835,18.6146229 L1.45466192,18.6146229 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.58281462 14.4171854 8.58281462 13 7.41827982 13 7.41827982 14.4171854 6 14.4171854 6 15.5817202 7.41827982 15.5817202 7.41827982 17 8.58281462 17 8.58281462 15.5817202 10 15.5817202 10 14.4171854"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPerMonthIcon);
export default __webpack_public_path__ + "static/media/patient-per-month-icon.32f75f7ef0f1c425c01f160b0d83aac4.svg";
export { ForwardRef as ReactComponent };